module.exports = __webpack_public_path__ + "static/media/greater_equal.b11277f9.svg";